webpackJsonp([17],{

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NetworkException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResponseException; });






var RuntimeException = function () {
  function RuntimeException(name, message) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RuntimeException);

    this._name = name;
    this._message = message;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RuntimeException, [{
    key: 'toString',
    value: function toString() {
      return this.name + '::' + this.message;
    }
  }, {
    key: 'name',
    get: function get() {
      return this._name;
    }
  }, {
    key: 'message',
    get: function get() {
      return this._message;
    }
  }]);

  return RuntimeException;
}();

var NetworkException = function (_RuntimeException) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(NetworkException, _RuntimeException);

  function NetworkException(message) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, NetworkException);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NetworkException.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(NetworkException)).call(this, 'NetworkException', message));
  }

  return NetworkException;
}(RuntimeException);

var ResponseException = function (_RuntimeException2) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ResponseException, _RuntimeException2);

  function ResponseException(message) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ResponseException);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ResponseException.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ResponseException)).call(this, 'ResponseException', message));
  }

  return ResponseException;
}(RuntimeException);

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_config__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_locutus_php_array_ksort__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_locutus_php_array_ksort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_locutus_php_array_ksort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_locutus_php_strings_md5__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_locutus_php_strings_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_locutus_php_strings_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Exception__ = __webpack_require__(110);














var apiMap = {
  post: {
    WeixinAuth: 'WeixinAuth',
    UserInComeList: 'UserInCome_Select',
    UserSplitFee: 'UserSplitFee_Select',
    UserListenList: 'UserListenList_Select',
    UserQuestionList: 'UserQuestionList_Select',
    AdBannerList: 'AdBannerList_Select',
    UserInfo: 'UserInfo_Select',
    UserAsk: 'UserAsk_Insert',
    UserListen: 'UserListen_Insert',
    UserLike: 'UserLike_Insert',
    IsLikeAnswer: 'IsLikeAnswer_Select',
    DoctorAroundIndex: 'DoctorAroundIndex_Select',
    PromotionList: 'PromotionList_Select',
    PromotionDetail: 'PromotionDetail_Select',
    QuestionList: 'QuestionList_Select',
    QuestionDetail: 'QuestionDetail_Select',
    getValidateCode: 'ValidateCode_Insert',
    checkValidateCode: 'ValidateCode_Check',
    changephoneValidateCode: 'ValidateChangePhoneCode_Check'

  },
  get: {}
};

var apiAxios = __WEBPACK_IMPORTED_MODULE_7_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_8_src_config___default.a.api.baseURL,
  timeout: 15000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'json' });

apiAxios.interceptors.request.use(function (config) {
  if (false) {
    console.log(config);
  }
  var payloadKey = config.method.toLowerCase() !== 'post' ? 'params' : 'data',
      payload = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({
    _timestamp: parseInt(Date.now() / 1000, 10)
  }, __WEBPACK_IMPORTED_MODULE_8_src_config___default.a.api.payload, config[payloadKey]);

  __WEBPACK_IMPORTED_MODULE_9_locutus_php_array_ksort___default()(payload);

  var signStr = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(payload).map(function (key) {
    return key + '=' + (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(payload[key]) === 'object' ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(payload[key]) : payload[key]);
  }).join("&") + ('&appkey=' + __WEBPACK_IMPORTED_MODULE_8_src_config___default.a.appKey),
      _sign = __WEBPACK_IMPORTED_MODULE_10_locutus_php_strings_md5___default()(signStr);
  if (false) {
    console.log(signStr, _sign);
  }
  config[payloadKey] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    _sign: _sign,
    signStr: signStr
  }, payload);

  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(new __WEBPACK_IMPORTED_MODULE_11__Exception__["a" /* NetworkException */](error));
});

apiAxios.interceptors.response.use(function (response) {
  var data = response.data;
  delete response.data;
  data._response = response;

  if (data.errcode == 0) {
    return data;
  } else {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(new __WEBPACK_IMPORTED_MODULE_11__Exception__["b" /* ResponseException */](data));
  }
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(new __WEBPACK_IMPORTED_MODULE_11__Exception__["a" /* NetworkException */](error));
});

function createApiMethod(axiosInstance, configMap) {
  var result = {};

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(configMap).forEach(function (method) {
    var dataIds = configMap[method];

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(dataIds).forEach(function (name) {

      var _dataid = dataIds[name];

      result[name] = function (_param) {
        _param || (_param = {});
        var payload = {
          _dataid: _dataid,
          _param: _param
        };
        return axiosInstance(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          url: 'api',
          method: method
        }, method !== 'post' ? 'params' : 'data', payload));
      };
    });
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (createApiMethod(apiAxios, apiMap));

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_Util__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* unused harmony export directive */






var directive = {
  'text-cut': function textCut(el, binding) {
    var value = binding.value,
        oldValue = binding.oldValue,
        arg = binding.arg,
        modifiers = binding.modifiers;

    var content = value,
        oldContent = oldValue;
    arg = parseInt(arg, 10);
    if (typeof value !== 'string' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(arg)) {
      arg = value.num || 0;
      content = value.content;
      oldContent = oldValue.content;
    }
    if (content !== oldContent) {
      el.innerText = __WEBPACK_IMPORTED_MODULE_2_lib_Util__["i" /* textCut */](content, arg, modifiers.dot);
    }
  },
  clamp: {
    inserted: function inserted(el, binding) {
      var value = binding.value,
          oldValue = binding.oldValue,
          arg = binding.arg;

      var content = value,
          oldContent = oldValue;
      arg = parseInt(arg, 10);
      if (typeof value !== 'string' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(arg)) {
        arg = value.line || 0;
        content = value.content;
        oldContent = oldValue.content;
      }

      if (content !== oldContent) {
        el.innerText = content;
        __webpack_require__(289)(el, { clamp: arg });
      }
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(directive).forEach(function (key) {
  return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.directive(key, directive[key]);
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var component = {
  template: '\n<div v-if="visible" class="layui-m-layer" v-bind:class="layerClass">\n  <div v-on:click="close()" v-if="isShade" class="layui-m-layershade" v-bind:class="shadeClass"></div>\n  <div class="layui-m-layermain">\n    <div class="layui-m-layersection">\n      <div v-if="type==2 && !skin" class="layui-m-layerchild  layui-m-anim-scale">\n        <div class="layui-m-layercont"><i></i> <i class="layui-m-layerload"></i> <i></i>\n          <div style="height:10px;width:100%;"></div>\n          <p>{{ content?content:"" }}</p>\n        </div>\n      </div>\n      <div v-if="ismsg" v-bind:style="msgStyle" class="layui-m-layerchild" :class="[skinClass,{\'layui-m-anim-up\':isUp}]">\n        <div class="layui-m-layercont" style="text-align:center;"> <i v-if="icon" style="display:block;font-size:40px;margin:22px" class="icon iconfont" :class="iconClass"></i> {{ content }} </div>\n      </div>\n      <div v-if="defaultChild" class="layui-m-layerchild" :class="[{\'layui-m-anim-up\':isUp}]">\n        <h3 :style="titleStyle" v-if="title">{{ titleText }}</h3>\n        <div  v-html="content" :class="contentClass" class="layui-m-layercont"></div>\n        <div v-if="btn" class="layui-m-layerbtn">\n          <template v-for="(item, index) in btn"> <span v-on:click="callback(index)" type="1">{{ item }}</span> </template>\n        </div>\n      </div>\n      <div v-if="isfooter" class="layui-m-layerchild" :class="[skinClass,{\'layui-m-anim-up\':isUp}]">\n        <div v-if="content" class="layui-m-layercont">{{ content }}</div>\n        <div class="layui-m-layerbtn">\n          <template v-for="(item, index) in btn"> <span :style="footerRadius(index)" v-if="index!=0" no="" v-on:click="callback(index)" type="1">{{ item }}</span> </template> <span v-if="btn.length>0" yes="" v-on:click="callback(0)" type="1">{{ btn[0] }}</span> </div>\n      </div>\n    </div>\n  </div>\n</div>',
  props: {
    'content': String,
    'type': {
      type: [Number, String],
      default: 0
    },
    'time': {
      type: Number,
      default: 0
    },
    'skin': {
      type: String
    },
    'btn': {
      type: [String, Array]
    },
    'title': {
      type: [Array, String]
    },
    'icon': {
      type: String
    },
    'callback': {
      type: Function
    },
    'contentClass': {
      type: String
    },
    'opacity': {
      type: Number,
      default: 7
    },
    'isUp': {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;

    this.visible = true;
    setTimeout(function () {
      _this.status = false;
    }, 3000);
    this.time > 0 ? setTimeout(function () {
      _this.visible = false;
    }, this.time) : '';
  },
  computed: {
    defaultChild: function defaultChild() {
      return this.type == 2 || this.skin == 'msg' || this.skin == 'footer' ? false : true;
    },
    layerClass: function layerClass() {
      return 'layui-m-layer' + this.type;
    },
    skinClass: function skinClass() {
      return 'layui-m-layer-' + this.skin;
    },
    shadeClass: function shadeClass() {
      return 'layui-m-layershade' + this.opacity;
    },
    msgStyle: function msgStyle() {
      return {
        bottom: this.icon ? 'auto' : ''
      };
    },
    iconClass: function iconClass() {
      return this.icon;
    },
    isShade: function isShade() {
      return this.type == 2 || this.skin == 'footer' || this.defaultChild ? true : false;
    },
    titleText: function titleText() {
      return typeof this.title == 'string' ? this.title : this.title[0];
    },
    titleStyle: function titleStyle() {
      return typeof this.title == 'string' ? '' : this.title[1];
    },
    ismsg: function ismsg() {
      return this.skin == 'msg';
    },
    isfooter: function isfooter() {
      return this.skin == 'footer';
    }
  },
  data: function data() {
    return {
      visible: false,
      status: true
    };
  },
  methods: {
    close: function close() {
      if (this.type === 2) {
        return false;
      }
      this.visible = false;
    },
    footerRadius: function footerRadius(index) {
      return this.btn[index + 1] ? 'border-radius:0;' : 'border-radius: 0 0 5px 5px;';
    }
  }
};
function getIndexLayer(Vue, props) {
  var layerIndex = Vue.extend(component);
  return new layerIndex({
    el: document.createElement('div'),
    propsData: props
  });
}
var layer = {
  v: '1.0',
  instanceList: [],
  open: function open(props) {
    this.close();
    var instance = getIndexLayer(this.vue, props);
    this.instanceList.push(instance);
    document.body.appendChild(instance.$el);
    return instance;
  },
  close: function close() {
    if (this.instanceList.length > 0) {
      var item = this.instanceList.pop();
      item.visible = false;
      this.close();
    }
    return false;
  },
  loading: function loading(_load) {
    var content = '',
        opacity = 7;
    if (typeof _load == 'string') {
      content = _load ? _load : '';
    } else {
      content = _load.content ? _load.content : '';
      opacity = _load.opacity;
    }
    var props = {
      content: content,
      opacity: opacity,
      type: 2
    };
    this.open(props);
  },
  toast: function toast(icon) {
    var props = {
      content: typeof icon == 'string' ? icon : icon.content ? icon.content : '',
      icon: icon.className ? icon.className : '',
      skin: 'msg',
      time: icon.time ? icon.time : 2000,
      isUp: icon.isUp ? true : false
    };
    this.open(props);
  },
  dialog: function dialog(_dialog) {
    var self = this;
    var props = {
      content: _dialog.content ? _dialog.content : '',
      time: _dialog.time ? _dialog.time : 0,
      title: _dialog.title ? _dialog.title : '',
      btn: _dialog.btn ? _dialog.btn : '',
      contentClass: _dialog.contentClass ? _dialog.contentClass : '',
      isUp: _dialog.isUp ? true : false
    };

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      props.callback = function (action) {
        resolve(action);
        self.close();
      };
      var instance = self.open(props);
    });
  },
  footer: function footer(data) {
    var self = this;
    var props = {
      skin: 'footer',
      content: data.content ? data.content : '',
      btn: data.btn ? data.btn : []
    };
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      props.callback = function (action) {
        resolve(action);
        self.close();
      };
      var instance = self.open(props);
    });
  }
};
layer.install = function (Vue, options) {
  layer.vue = Vue;
  Vue.prototype.$layer = layer;
};

/* harmony default export */ __webpack_exports__["a"] = (layer);

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_wechat_title__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_wechat_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_wechat_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_CurrentUser__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_Util__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_config__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_src_config__);








var Index = function Index(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(614)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Home = function Home(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(610)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var EventDetails = function EventDetails(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(613)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Userask = function Userask(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(625)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var QuestDetails = function QuestDetails(resolve) {
  return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(624)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var My = function My(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(611)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var IncomeDetails = function IncomeDetails(resolve) {
  return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(619)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PercentDetails = function PercentDetails(resolve) {
  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(622)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var MyAsks = function MyAsks(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(620)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var MyListens = function MyListens(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(621)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Helps = function Helps(resolve) {
  return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(618)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ChangePhone = function ChangePhone(resolve) {
  return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(616)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var BindPhone = function BindPhone(resolve) {
  return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(615)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var FirstBindPhone = function FirstBindPhone(resolve) {
  return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(617)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var SecondBindPhone = function SecondBindPhone(resolve) {
  return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(623)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Empty = function Empty(resolve) {
  return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(608)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_wechat_title___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: "history",
  base: "/member",
  routes: [{ path: '/', redirect: '/home' }, { path: '/home', name: 'home', component: Home, meta: { title: '名医问答', tabBar: true, home: true } }, { path: '/event', name: 'eventdetails', component: EventDetails, meta: { title: '活动详情' } }, { path: '/userask', name: 'userask', component: Userask, meta: { title: '立即提问' } }, { path: '/question', name: 'questdetails', component: QuestDetails, meta: { title: '问题详情' } }, { path: '/my', name: 'my', component: My, meta: { title: '名医问答', tabBar: true, my: true } }, { path: '/my/income', name: 'income', component: IncomeDetails, meta: { title: '收益明细' } }, { path: '/my/percent', name: 'percent', component: PercentDetails, meta: { title: '提成明细' } }, { path: '/my/myasks', name: 'myasks', component: MyAsks, meta: { title: '我的提问' } }, { path: '/my/mylistens', name: 'mylistens', component: MyListens, meta: { title: '我的收听' } }, { path: '/my/helps', name: 'helps', component: Helps, meta: { title: '帮助中心' } }, { path: '/my/changephone', name: 'changephone', component: ChangePhone, meta: { title: '更换手机' } }, { path: '/my/bindphone', name: 'bindphone', component: BindPhone, meta: { title: '绑定手机' } }, { path: '/my/firstbindphone', name: 'firstbindphone', component: FirstBindPhone, meta: { title: '绑定手机号' } }, { path: '/my/secondbindphone', name: 'secondbindphone', component: SecondBindPhone, meta: { title: '更换手机号' } }, { path: '*', name: 'empty', component: Empty, meta: { title: '404' } }]

});

if (true) {
  router.beforeEach(function (to, from, next) {
    var uid = __WEBPACK_IMPORTED_MODULE_5_lib_Util__["d" /* getCookie */]('userid'),
        promise = void 0;
    if (!uid) {
      promise = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject("need Login");
    } else {
      promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lib_CurrentUser__["a" /* default */])();
    }

    promise.then(function (res) {
      if (res) {
        return next();
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    }).catch(function (e) {
      window.location.href = __WEBPACK_IMPORTED_MODULE_6_src_config___default.a.Auth.Login.replace(/\{url\}/g, encodeURIComponent(window.location.origin + router.history.base + to.fullPath));
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(562)

var Component = __webpack_require__(250)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(600),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_config__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Util__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Net__ = __webpack_require__(159);
/* unused harmony export isWeixin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ready; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInstance; });







var ua = window.navigator.userAgent,
    matched = ua.match(/MicroMessenger/i);

var isWeixin =  false ? true : matched && matched[0] && matched[0].toLowerCase() == 'micromessenger';

var _promises = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(1)];
if (isWeixin && !window.wx) {
  _promises.push(__WEBPACK_IMPORTED_MODULE_3__Util__["b" /* loadJS */](__WEBPACK_IMPORTED_MODULE_2_src_config___default.a.wx.defaultSDK));
}

var url = window.location.href.split('#')[0];
var ready = function ready() {
  if (isWeixin) {
    if (__WEBPACK_IMPORTED_MODULE_3__Util__["c" /* os */].isAndroid) {
      url = window.location.href.split("#")[0];
    }

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([].concat(_promises, __WEBPACK_IMPORTED_MODULE_4__Net__["a" /* default */].WeixinAuth({ url: url }))).then(function (result) {
      var data = result[result.length - 1].data;

      var wx = window.wx;

      if (false) {
        console.log(data);
      }

      wx.config(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        jsApiList: __WEBPACK_IMPORTED_MODULE_2_src_config___default.a.wx.jsApiList
      }, data));

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        wx.ready(function () {
          resolve(wx);
        });

        wx.error(reject);
      });
    });
  }
};

var getInstance = function getInstance() {
  return window.wx;
};

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Net__ = __webpack_require__(159);
/* unused harmony export refresh */



var User = void 0;

function getUser() {
  if (User) {
    return User;
  }

  return User = __WEBPACK_IMPORTED_MODULE_0__Net__["a" /* default */].UserInfo().then(function (_ref) {
    var data = _ref.data;
    return data;
  }).catch(function (e) {
    return false;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (getUser);

var refresh = function refresh() {
  User = null;
  return getUser();
};

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_Wx__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_Util__ = __webpack_require__(83);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            event: ''
        };
    },
    created: function created() {
        this.wxPromise = __WEBPACK_IMPORTED_MODULE_2_lib_Wx__["a" /* ready */]();
        this.setShare();
    },

    watch: {
        '$route': function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.setShare();

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function $route() {
                return _ref.apply(this, arguments);
            }

            return $route;
        }()
    },
    methods: {
        onSwipeRight: function onSwipeRight() {
            this.$router.go(-1);
            return false;
        },
        changeTab: function changeTab(type) {
            this.$router.push({ name: type });
        },
        setShare: function setShare(config) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var wxInstance;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                config = __WEBPACK_IMPORTED_MODULE_3_lib_Util__["a" /* shareConfig */](config);
                                if (false) {
                                    console.log(config);
                                }
                                _context2.next = 4;
                                return _this.wxPromise;

                            case 4:
                                wxInstance = _context2.sent;

                                wxInstance.onMenuShareTimeline(config);
                                wxInstance.onMenuShareAppMessage(config);
                                wxInstance.onMenuShareQQ(config);
                                wxInstance.onMenuShareWeibo(config);
                                wxInstance.onMenuShareQZone(config);

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        }
    }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  "appKey": "key",
  "host": "",
  "imgBaseUrl": "http://images.mkzoo.com",
  "baseConfig": {
    "agreeUrl": "https://m.baidu.com/"
  },
  "Auth": {
    "Login": "http://api.baozhuanla.com/auth/login?url={url}"
  },
  "api": {
    "baseURL": "/",
    "payload": {
      "_source": "weixin"
    }
  },
  "wx": {
    "shareConfig": {
      "title": "「名医问答」-知名专家在线答疑解惑，大病小病你来问",
      "desc": "「铁锋帮你忙」栏目组倾情打造的健康咨询平台，名医解答，惠及百姓",
      "link": "/member/home",
      "imgUrl": "http://images.mkzoo.com/2017-03/share-icon.jpg"
    },
    "jsApiList": ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "chooseWXPay", "startRecord", "stopRecord", "onVoiceRecordEnd", "playVoice", "pauseVoice", "stopVoice", "onVoicePlayEnd", "uploadVoice", "downloadVoice"],
    "defaultSDK": "//res.wx.qq.com/open/js/jweixin-1.0.0.js"
  },
  "Storage": {
    "storageId": "DOCTOR_DEV",
    "liftTime": 30 * 24 * 60 * 60 * 1000
  }
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  "appKey": "key",
  "host": "",
  "imgBaseUrl": "http://images.mkzoo.com",
  "baseConfig": {
    "agreeUrl": "https://m.baidu.com/"
  },
  "Auth": {
    "Login": "http://api.baozhuanla.com/auth/login?url={url}"
  },
  "api": {
    "baseURL": "//api.baozhuanla.com/service/",
    "payload": {
      "_source": "weixin"
    }
  },
  "wx": {
    "shareConfig": {
      "title": "「名医问答」-知名专家在线答疑解惑，大病小病你来问",
      "desc": "「铁锋帮你忙」栏目组倾情打造的健康咨询平台，名医解答，惠及百姓",
      "link": "/member/home",
      "imgUrl": "http://images.mkzoo.com/2017-03/share-icon.jpg"
    },
    "jsApiList": ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "chooseWXPay", "startRecord", "stopRecord", "onVoiceRecordEnd", "playVoice", "pauseVoice", "stopVoice", "onVoicePlayEnd", "uploadVoice", "downloadVoice"],
    "defaultSDK": "//res.wx.qq.com/open/js/jweixin-1.0.0.js"
  },
  "Storage": {
    "storageId": "DOCTOR_PROD",
    "liftTime": 30 * 24 * 60 * 60 * 1000
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, exports) {



(function () {
  function clamp(element, options) {
    options = options || {};

    var self = this,
        win = window,
        opt = {
      clamp: options.clamp || 2,
      useNativeClamp: typeof options.useNativeClamp != 'undefined' ? options.useNativeClamp : true,
      splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '],
      animate: options.animate || false,
      truncationChar: options.truncationChar || '…',
      truncationHTML: options.truncationHTML
    },
        sty = element.style,
        originalText = element.innerHTML,
        supportsNativeClamp = typeof element.style.webkitLineClamp != 'undefined',
        clampValue = opt.clamp,
        isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
        truncationHTMLContainer;

    if (opt.truncationHTML) {
      truncationHTMLContainer = document.createElement('span');
      truncationHTMLContainer.innerHTML = opt.truncationHTML;
    }

    function computeStyle(elem, prop) {
      if (!win.getComputedStyle) {
        win.getComputedStyle = function (el, pseudo) {
          this.el = el;
          this.getPropertyValue = function (prop) {
            var re = /(\-([a-z]){1})/g;
            if (prop == 'float') prop = 'styleFloat';
            if (re.test(prop)) {
              prop = prop.replace(re, function () {
                return arguments[2].toUpperCase();
              });
            }
            return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
          };
          return this;
        };
      }

      return win.getComputedStyle(elem, null).getPropertyValue(prop);
    }

    function getMaxLines(height) {
      var availHeight = height || element.clientHeight,
          lineHeight = getLineHeight(element);

      return Math.max(Math.floor(availHeight / lineHeight), 0);
    }

    function getMaxHeight(clmp) {
      var lineHeight = getLineHeight(element);
      return lineHeight * clmp;
    }

    function getLineHeight(elem) {
      var lh = computeStyle(elem, 'line-height');
      if (lh == 'normal') {
        lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
      }
      return parseInt(lh);
    }

    var splitOnChars = opt.splitOnChars.slice(0),
        splitChar = splitOnChars[0],
        chunks,
        lastChunk;

    function getLastChild(elem) {
      if (elem.lastChild.children && elem.lastChild.children.length > 0) {
        return getLastChild(Array.prototype.slice.call(elem.children).pop());
      } else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue == '' || elem.lastChild.nodeValue == opt.truncationChar) {
          elem.lastChild.parentNode.removeChild(elem.lastChild);
          return getLastChild(element);
        } else {
            return elem.lastChild;
          }
    }

    function truncate(target, maxHeight) {
      if (!maxHeight) {
        return;
      }

      function reset() {
        splitOnChars = opt.splitOnChars.slice(0);
        splitChar = splitOnChars[0];
        chunks = null;
        lastChunk = null;
      }

      var nodeValue = target.nodeValue.replace(opt.truncationChar, '');

      if (!chunks) {
        if (splitOnChars.length > 0) {
          splitChar = splitOnChars.shift();
        } else {
            splitChar = '';
          }

        chunks = nodeValue.split(splitChar);
      }

      if (chunks.length > 1) {
        lastChunk = chunks.pop();

        applyEllipsis(target, chunks.join(splitChar));
      } else {
          chunks = null;
        }

      if (truncationHTMLContainer) {
        target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
        element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
      }

      if (chunks) {
        if (element.clientHeight <= maxHeight) {
          if (splitOnChars.length >= 0 && splitChar != '') {
            applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
            chunks = null;
          } else {
              return element.innerHTML;
            }
        }
      } else {
          if (splitChar == '') {
            applyEllipsis(target, '');
            target = getLastChild(element);

            reset();
          }
        }

      if (opt.animate) {
        setTimeout(function () {
          truncate(target, maxHeight);
        }, opt.animate === true ? 10 : opt.animate);
      } else {
        return truncate(target, maxHeight);
      }
    }

    function applyEllipsis(elem, str) {
      elem.nodeValue = str + opt.truncationChar;
    }

    if (clampValue == 'auto') {
      clampValue = getMaxLines();
    } else if (isCSSValue) {
      clampValue = getMaxLines(parseInt(clampValue));
    }

    var clampedText;
    if (supportsNativeClamp && opt.useNativeClamp) {
      sty.overflow = 'hidden';
      sty.textOverflow = 'ellipsis';
      sty.webkitBoxOrient = 'vertical';
      sty.display = '-webkit-box';
      sty.webkitLineClamp = clampValue;

      if (isCSSValue) {
        sty.height = opt.clamp + 'px';
      }
    } else {
      var height = getMaxHeight(clampValue);
      if (height <= element.clientHeight) {
        clampedText = truncate(getLastChild(element), height);
      }
    }

    return {
      'original': originalText,
      'clamped': clampedText
    };
  }

  module.exports = clamp;
})();

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_directive__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_vue_layer_mobile__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_Exception__ = __webpack_require__(110);










__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__webpack_require__(249));
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__webpack_require__(247));
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__webpack_require__(158));
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_lib_vue_layer_mobile__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App ref="app"/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

window.onunhandledrejection = function (event) {
  if (true) {
    event.preventDefault && event.preventDefault();
  }
  var promise = event.promise,
      $layer = app.$layer;

  promise.catch(function (ex) {
    if (false) {
      console.log('系统错误==========================');
      console.log(ex);
    }
    if (ex instanceof __WEBPACK_IMPORTED_MODULE_6_lib_Exception__["a" /* NetworkException */]) {
      if (ex.message.code) {
        $layer.toast("系统正忙，请稍后再试【" + ex.message.code + "】：" + ex.message.message);
      } else {
        $layer.toast("系统正忙，请稍后再试：" + ex.message.message);
      }
    } else if (ex instanceof __WEBPACK_IMPORTED_MODULE_6_lib_Exception__["b" /* ResponseException */]) {
      var _ex$message = ex.message,
          errcode = _ex$message.errcode,
          errmsg = _ex$message.errmsg;

      if (errcode >= 3000 && errcode <= 3999) {
        $layer.toast(errmsg);
      } else if (errcode >= 5000 && errcode <= 5999) {
        $layer.dialog({
          content: errmsg,
          btn: ["知道了"]
        });
      }
    }
  });
};

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports = {
	"modp1": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
	},
	"modp2": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
	},
	"modp5": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
	},
	"modp14": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
	},
	"modp15": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
	},
	"modp16": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
	},
	"modp17": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
	},
	"modp18": {
		"gen": "02",
		"prime": "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"
	}
};

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

module.exports = {
	"_args": [
		[
			{
				"raw": "elliptic@^6.0.0",
				"scope": null,
				"escapedName": "elliptic",
				"name": "elliptic",
				"rawSpec": "^6.0.0",
				"spec": ">=6.0.0 <7.0.0",
				"type": "range"
			},
			"D:\\wamp\\www\\doctor\\node_modules\\browserify-sign"
		]
	],
	"_cnpm_publish_time": 1487798867116,
	"_from": "elliptic@>=6.0.0 <7.0.0",
	"_id": "elliptic@6.4.0",
	"_inCache": true,
	"_installable": true,
	"_location": "/elliptic",
	"_nodeVersion": "7.0.0",
	"_npmOperationalInternal": {
		"host": "packages-18-east.internal.npmjs.com",
		"tmp": "tmp/elliptic-6.4.0.tgz_1487798866428_0.30510620190761983"
	},
	"_npmUser": {
		"name": "indutny",
		"email": "fedor@indutny.com"
	},
	"_npmVersion": "3.10.8",
	"_phantomChildren": {},
	"_requested": {
		"raw": "elliptic@^6.0.0",
		"scope": null,
		"escapedName": "elliptic",
		"name": "elliptic",
		"rawSpec": "^6.0.0",
		"spec": ">=6.0.0 <7.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/browserify-sign",
		"/create-ecdh"
	],
	"_resolved": "https://registry.npm.taobao.org/elliptic/download/elliptic-6.4.0.tgz",
	"_shasum": "cac9af8762c85836187003c8dfe193e5e2eae5df",
	"_shrinkwrap": null,
	"_spec": "elliptic@^6.0.0",
	"_where": "D:\\wamp\\www\\doctor\\node_modules\\browserify-sign",
	"author": {
		"name": "Fedor Indutny",
		"email": "fedor@indutny.com"
	},
	"bugs": {
		"url": "https://github.com/indutny/elliptic/issues"
	},
	"dependencies": {
		"bn.js": "^4.4.0",
		"brorand": "^1.0.1",
		"hash.js": "^1.0.0",
		"hmac-drbg": "^1.0.0",
		"inherits": "^2.0.1",
		"minimalistic-assert": "^1.0.0",
		"minimalistic-crypto-utils": "^1.0.0"
	},
	"description": "EC cryptography",
	"devDependencies": {
		"brfs": "^1.4.3",
		"coveralls": "^2.11.3",
		"grunt": "^0.4.5",
		"grunt-browserify": "^5.0.0",
		"grunt-cli": "^1.2.0",
		"grunt-contrib-connect": "^1.0.0",
		"grunt-contrib-copy": "^1.0.0",
		"grunt-contrib-uglify": "^1.0.1",
		"grunt-mocha-istanbul": "^3.0.1",
		"grunt-saucelabs": "^8.6.2",
		"istanbul": "^0.4.2",
		"jscs": "^2.9.0",
		"jshint": "^2.6.0",
		"mocha": "^2.1.0"
	},
	"directories": {},
	"dist": {
		"shasum": "cac9af8762c85836187003c8dfe193e5e2eae5df",
		"size": 41164,
		"noattachment": false,
		"tarball": "http://registry.npm.taobao.org/elliptic/download/elliptic-6.4.0.tgz"
	},
	"files": [
		"lib"
	],
	"gitHead": "6b0d2b76caae91471649c8e21f0b1d3ba0f96090",
	"homepage": "https://github.com/indutny/elliptic",
	"keywords": [
		"EC",
		"Elliptic",
		"curve",
		"Cryptography"
	],
	"license": "MIT",
	"main": "lib/elliptic.js",
	"maintainers": [
		{
			"name": "indutny",
			"email": "fedor@indutny.com"
		}
	],
	"name": "elliptic",
	"optionalDependencies": {},
	"publish_time": 1487798867116,
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/indutny/elliptic.git"
	},
	"scripts": {
		"jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"lint": "npm run jscs && npm run jshint",
		"test": "npm run lint && npm run unit",
		"unit": "istanbul test _mocha --reporter=spec test/index.js",
		"version": "grunt dist && git add dist/"
	},
	"version": "6.4.0"
};

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

module.exports = {
	"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
	"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
	"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
	"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
	"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
	"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
	"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
	"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
	"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
	"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
	"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
	"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    directives: [{
      name: "wechat-title",
      rawName: "v-wechat-title",
      value: (_vm.$route.meta.title),
      expression: "$route.meta.title"
    }]
  }), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.meta.tabBar),
      expression: "this.$route.meta.tabBar"
    }],
    staticClass: "bar tabbar"
  }, [_c('a', {
    staticClass: "tab-index router",
    class: {
      active: this.$route.meta.home
    },
    on: {
      "click": function($event) {
        _vm.changeTab('home')
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('a', {
    staticClass: "tab-my router",
    class: {
      active: this.$route.meta.my
    },
    on: {
      "click": function($event) {
        _vm.changeTab('my')
      }
    }
  }, [_vm._v("我的")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAABGUlEQVQokY3SvyvEcRzH8ccdLsMNBgbbZTCeiSxIDOdHCYPxisUfYCeLyazvYKEsDAb5kZKBXJksyCpGSpEiGb7f4+K+37vX9qnX89P7/Xq9U0EQZNCBW3UojWXcYA1N9QCneMc8jtFaCzhEPx4wgEvkkwCRqQcl5HCOqSQAHjGIDWSxg0Wk4gDRLkUs4AtL2I4+qAqUtYoxPGMaZ9GosQAcoVfYT5dwz9kkAO4iaF8Y93otAF5wVX401jA3IMAcPrGSBDRjC5N4wwz24oAW7Aqbf8I4LuJGaheeSx73KOA6bodOYZy5yFSIoB9VptTtt6AS+v6aK4EhnKANBxiOZv+nNEaFxWSxiQm8VjOXgRFkhPdTxEecGb4BWcQ4/8eot5AAAAAASUVORK5CYII="

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_config__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_src_config__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return bLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return compleImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shareConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return textCut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return os; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPlatStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getShowNum; });



var doc = document;

var loadJS = function loadJS(url) {

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var script = doc.createElement('script');
    script.type = 'text/javascript';
    script.onload = function () {
      this.onload = this.onerror = null;
      resolve(this);
      this.parentNode.removeChild(this);
    };

    script.onerror = function () {
      reject(this);
    };

    script.src = url;
    doc.getElementsByTagName('head')[0].appendChild(script);
  });
};

var bLength = function bLength(str) {
  return (str + "").replace(/[^\x00-\xff]/g, '**').length;
};

var compleImage = function compleImage(value) {
  if (value) {
    if (value.indexOf("http") < 0) {
      return __WEBPACK_IMPORTED_MODULE_1_src_config___default.a.imgBaseUrl + value;
    } else {
      return value;
    }
  } else {
    return value;
  }
};

var shareConfig = function shareConfig(config) {
  if (config == null || config == undefined) {
    config = {};
  }

  var baseUrl = 'http://' + window.location.host;
  var shareConfig = {};
  shareConfig = {
    'title': config.title ? config.title : __WEBPACK_IMPORTED_MODULE_1_src_config___default.a.wx.shareConfig.title,
    'desc': config.desc ? config.desc : __WEBPACK_IMPORTED_MODULE_1_src_config___default.a.wx.shareConfig.desc,
    'link': config.link ? config.link : baseUrl + __WEBPACK_IMPORTED_MODULE_1_src_config___default.a.wx.shareConfig.link,
    'imgUrl': config.imgUrl ? config.imgUrl : __WEBPACK_IMPORTED_MODULE_1_src_config___default.a.wx.shareConfig.imgUrl
  };
  return shareConfig;
};

var textCut = function textCut(str, num, dot) {
  num = parseInt(num, 10);
  if (isNaN(num)) {
    num = 75;
  }

  var len = bLength(str),
      newLen = 0,
      newStr = "";

  if (len <= num * 2) {
    return str;
  }
  for (var i = 0; i < len; i++) {
    var tmp = str.charCodeAt(i);
    if (tmp > 255) {
      newLen++;
    }
    newLen++;
    if (newLen >= num * 2) {
      break;
    }
    newStr += str[i];
  }

  return newStr + (dot ? "..." : "");
};

var os = function () {
  "use strict";

  var ua = window.navigator.userAgent,
      matched = void 0;
  var os = {
    name: "unknown",
    version: "0.0.0"
  };

  if (matched = ua.match(/Windows\sPhone\s(?:OS\s)?([\d\.]+)/)) {
    os = {
      name: 'Windows Phone',
      isWindowsPhone: true,
      version: matched[1]
    };
  } else if (!!ua.match(/Safari/) && (matched = ua.match(/Android[\s\/]([\d\.]+)/))) {
    os = {
      version: matched[1]
    };

    if (!!ua.match(/Mobile\s+Safari/)) {
      os.name = 'Android';
    } else {
      os.name = 'AndroidPad';
      os.isAndroidPad = true;
    }
    os.isAndroid = true;
  } else if (matched = ua.match(/(iPhone|iPad|iPod)/)) {
    var name = matched[1];

    matched = ua.match(/OS ([\d_\.]+) like Mac OS X/);

    os = {
      name: name,
      isIphone: name === 'iPhone' || name === 'iPod',
      isIpad: name === 'iPad',
      isIOS: true,
      version: matched[1].split('_').join('.')
    };
  }

  return os;
}();

var getCookie = function getCookie(name) {
  var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
  if (arr != null) {
    return unescape(arr[2]);
  }
  return null;
};

var getPlatStyle = function getPlatStyle(type) {
  var isIOS = os.isIOS;
  var height = 0;
  if (type == 'bth-ask') {
    height = isIOS ? 0 : 30;
  } else if (type == 'quest-bottom') {
    height = isIOS ? 100 : 100;
  } else if (type == 'lastspace') {
    height = isIOS ? 68 : 38;
  }
  var params = { height: height };
  return params;
};

var getShowNum = function getShowNum(num) {
  var number = 0;
  if (num > 99999) {
    number = '99999+';
  } else {
    number = num;
  }
  return number;
};

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {


var env = "production";
if (env === "development") {
  module.exports = __webpack_require__(287);
} else {
  module.exports = __webpack_require__(288);
}

/***/ })

},[290]);


// WEBPACK FOOTER //
// static/js/app.33f0f2e9323c32bf3760.js